export const queryKey = {
	permissions: 'permissions',
	jobUsage: 'jobUsage',
	partnersInsight: 'partnersInsight',
	jobInsight: 'jobInsight',
	bpProfileInsight: 'bpProfileInsight',
	cpProfileInsight: 'cpProfileInsight',
	jobUsageGeneral: 'jobUsageGeneral',
	graph: 'graph',
	group: 'group',
	groups: 'groups',
	role: 'role',
	credits: 'credits',
	credit: 'credit',
	searchWithAnalyticsJobs: 'searchWithAnalyticsJobs',
	partnerDetails: 'partnerDetails',
	branches: 'branches',
	branch: 'branch',
	invoiceList: 'invoiceList',
	invoiceDetails: 'invoiceDetails',
	paymentsList: 'paymentsList',
	agentPartnersArea: 'agentPartnersArea',
	alternativeRegion: 'alternativeRegion',
	businessPartnerProfile: 'businessPartnerProfile',
	communityPartnerProfile: 'communityPartnerProfile',
	subscriptionPaymentsList: 'subscriptionPaymentsList',
	commissionLevelMe: 'commissionLevelMe',
	subscriptionPlansCommissionGroups: 'subscriptionPlansCommissionGroups',
	subscriptionPlansFeature: 'subscriptionPlansFeature',
	communityPartnerAssociation: 'communityPartnerAssociation',
	businessPartnerMe: 'businessPartnerMe',
	paymentMethods: 'paymentMethods',
	communityPartnerMe: 'communityPartnerMe',
	agentPartners: 'agentPartners',
	communityPartnerPartners: 'communityPartnerPartners',
	communityPartners: 'communityPartners',
	communityPartnerTypes: 'communityPartnerTypes',
	profile: 'profile',
	employee: 'employee',
	employees: 'employees',
	member: 'member',
	members: 'members',
	activityTag: 'activityTag',
	regions: 'regions',
	region: 'region',
	activity: 'activity',
	activities: 'activities',
	sector: 'sector',
	sectors: 'sectors',
	jobType: 'jobType',
	jobTypes: 'jobTypes',
	job: 'job',
	jobs: 'jobs',
	publishJobs: 'publishJobs',
	jobTagCategories: 'jobTagCategories',
	internship: 'internship',
	internships: 'internships',
	internshipParticipants: 'internshipParticipants',
	jobQrCode: 'jobQrCode',
	downloadJobQrCode: 'downloadJobQrCode',
	user: 'user',
	users: 'users',
	benefit: 'benefit',
	benefits: 'benefits',
	subscriptionPlans: 'subscriptionPlans',
	subscriptionPrimaryPlans: 'subscriptionPrimaryPlans',
	subscription: 'subscription',
	subscriptionCalculate: 'subscriptionCalculate',
	subscriptionCalculateUpgrade: 'subscriptionCalculateUpgrade',
	subscriptions: 'subscriptions',
	subscriptionPayments: 'subscriptionPayments',
	subscriptionsPrimary: 'subscriptionsPrimary',
	demands: 'demands',
	demand: 'demand',
	transaction: 'transaction',
	transactions: 'transactions',
	payment: 'payment',
	pay: 'pay',
	payments: 'payments',
	paymentStatus: 'paymentStatus',
	paymentTransaction: 'paymentTransaction',
	voucher: 'voucher',
	vouchers: 'vouchers',
	availableVouchers: 'availableVouchers',
	invitation: 'invitation',
	invitations: 'invitations',
	event: 'event',
	eventDetails: 'eventDetails',
	eventLimit: 'eventLimit',
	events: 'events',
	publicEvents: 'publicEvents',
	companiesToInvite: 'companiesToInvite',
	participants: 'participants',
	eventInvitations: 'eventInvitations',
	eventAllInvitations: 'eventAllInvitations',
	companyEventInvitations: 'companyEventInvitations',
	companyParticipatedEvent: 'companyParticipatedEvent',
	marketingAssets: 'marketingAssets',
	marketingTemplates: 'marketingTemplates',
	marketingAssetConfig: 'marketingAssetConfig',
	agentToSwitch: 'agentToSwitch',
	department: 'department',
	departments: 'departments',
	linkedinToken: 'linkedinToken',
	jobStatistics: 'jobStatistics',
	totalJobStatistics: 'totalJobStatistics',
	contactGroup: 'contactGroup',
	contactPeople: 'contactPeople',
	agentPlans: 'agentPlans',
	agentPlan: 'agentPlan',
	aboCalculator: 'aboCalculator'
};
